import { render, staticRenderFns } from "./HomeBlockText.vue?vue&type=template&id=6c4a7f80&scoped=true&name=home-block-text&"
import script from "./HomeBlockText.vue?vue&type=script&lang=js&"
export * from "./HomeBlockText.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlockText.vue?vue&type=style&index=0&id=6c4a7f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a7f80",
  null
  
)

export default component.exports